/**
 * Central place for DinDin POS API base URL.
 *
 * - In development, defaults to a same-origin path so Create React App's `proxy`
 *   can forward requests and avoid browser CORS issues.
 * - In production, uses the public API host unless overridden.
 *
 * Override anytime with: REACT_APP_DINDIN_API_BASE_URL=https://example.com/api/v1
 */
const PUBLIC_API_ORIGIN = 'https://dev.dindinpos.com';
const API_VERSION_PATH = '/api/v1/dindin-web';

function resolveBaseUrl() {
  if (process.env.REACT_APP_DINDIN_API_BASE_URL) {
    return process.env.REACT_APP_DINDIN_API_BASE_URL.replace(/\/$/, '');
  }
  return `${PUBLIC_API_ORIGIN}${API_VERSION_PATH}`;
}

export const DINDIN_API_BASE_URL = resolveBaseUrl();

/**
 * Where static assets (e.g. cuisine image_url) should be loaded from.
 *
 * Why separate from API base:
 * - API base might be `/api/v1` (dev proxy), but images often come back as `/storage/...`
 * - Images cannot be fetched through CRA's API proxy unless you also proxy those paths
 *
 * Override anytime with: REACT_APP_DINDIN_ASSET_ORIGIN=http://pos_temp.test
 */
export const DINDIN_ASSET_ORIGIN =
  process.env.REACT_APP_DINDIN_ASSET_ORIGIN ||
  (process.env.NODE_ENV === 'development'
    ? 'http://pos_temp.test'
    : PUBLIC_API_ORIGIN);
